export default "__VITE_ASSET__Cls8etoQ__"